import React from "react";
import "../index.css";
import Top from "./HomeComponents/Top";
import Footer from "./HomeComponents/Footer";
import AppFeatures from "./HomeComponents/AppFeatures";
import ProjectLayout from "./HomeComponents/ProjectLayout";
import DeveloperSection from "./HomeComponents/DeveloperSection";
import data from "../data/data.json";
import { useTheme } from "../contexts/ThemeContext";
import StarField from "./StarField";

function Home() {
    const { isDark } = useTheme();

    return (
        <div className="relative min-h-screen">
            {/* Star field background - only show in dark mode */}
            {isDark && <StarField />}
            
            {/* Main content */}
            <div className="relative z-10">
                <Top />
                <AppFeatures />
                <ProjectLayout data={data} />
                <DeveloperSection />
                <Footer />
            </div>
        </div>
    );
}

export default Home;
